// extracted by mini-css-extract-plugin
export default {"card":"Card_card__CNGer","hover":"Card_hover__XjQBP","title":"Card_title__EjVBq","content":"Card_content__mSe9S"};